import { gql } from '@apollo/client';

export interface DubboProviderInfo {
  host: string;
  port: number;
  version: string;
  group: string;
}

export const DUBBO_QUERY_PROVIDERS = gql`
  query DubboQueryProviders($interfaceName: String!) {
    dubboQueryProviders(interfaceName: $interfaceName) {
      host
      port
      version
      group
    }
  }
`;

export const DUBBO_GENERIC_INVOKE = gql`
  mutation DubboGenericInvoke(
    $host: String!
    $port: Int!
    $interfaceName: String!
    $version: String!
    $group: String!
    $methodName: String!
    $paramTypes: [String!]!
    $argsJson: [String!]!
  ) {
    dubboGenericInvoke(
      host: $host
      port: $port
      interfaceName: $interfaceName
      version: $version
      group: $group
      methodName: $methodName
      paramTypes: $paramTypes
      argsJson: $argsJson
    )
  }
`;
